import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { history } from '../../../_services/essentials/helpers';
import { userActions, alertActions } from '../../../_services/essentials/store';
import { UserAgreement } from './UserAgreement'
import { Button } from "@mui/material";
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { TextField, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { ArrowForwardOutlined } from '@mui/icons-material';

export { Register };

function Register() {
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    // form validation rules
    const validationSchema = Yup.object().shape({
        firstname: Yup.string()
            .required('First Name is required'),
        lastname: Yup.string()
            .required('Last Name is required'),
        email: Yup.string().email("Please enter a valid Email")
            .required('Email is required'),
        password: Yup.string()
            .required('Password is required')
            .min(6, 'Password must be at least 6 characters')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    //    const { errors, isSubmitting } = formState;
    const { errors } = formState;

    const [agreementSigned, setAgreementSigned] = useState(false);
    const [agreementPage, setAgreementPage] = React.useState(false);

    const handleClickAgreementPageOpen = () => {
        setAgreementPage(true);
    };

    const handleAgreementPageClose = () => {
        setAgreementPage(false);
    };


    async function onSubmit(data) {
        dispatch(alertActions.clear());

        try {
            const response = await dispatch(userActions.register(data)).unwrap();
            if (response === "New user account registered successfully. We will contact you to complete the account activation.") {
                // redirect to login page and display success alert
                history.navigate('/account/login');
                dispatch(alertActions.success({ message: response, showAfterRedirect: true }));
            }
            else { dispatch(alertActions.error({ message: response })); }
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    // const Card = styled(MuiCard)(({ theme }) => ({
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignSelf: 'center',
    //     width: '100%',
    //     padding: theme.spacing(4),
    //     gap: theme.spacing(2),
    //     margin: 'auto',
    //     boxShadow:
    //         'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    //     [theme.breakpoints.up('sm')]: {
    //         width: '80%',
    //         maxWidth: '500px'
    //     },
    //     ...theme.applyStyles('dark', {
    //         boxShadow:
    //             'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    //     }),
    // }));

    return (
        //         <Stack
        //             sx={{
        //                 justifyContent: 'center',
        // //                height: '100dvh',
        //                 p: 2
        //             }}
        //         >
        //             <Card variant="outlined">
        //                 <Typography
        //                     component="h1"
        //                     variant="h4"
        //                     sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
        //                 >
        //                     Sign up
        //                 </Typography>
        //                 <form onSubmit={handleSubmit(onSubmit)}>
        //                 <Box
        //                     sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
        //                 >
        //                     <FormControl>
        //                         <FormLabel htmlFor="firstname">First name*</FormLabel>
        //                         <TextField
        //                             id="firstname"
        //                             name="firstname"
        //                             type="text"
        //                             autoFocus
        //                             fullWidth
        //                             placeholder=""
        //                             autoComplete="off"
        //                             defaultValue={""}
        //                             {...register('firstname', {required: true})}
        //                             error={Boolean(errors.firstname)}
        //                             helperText={errors.firstname ? errors.firstname.message : ""}
        //                         />
        //                     </FormControl>
        //                     <FormControl>
        //                         <FormLabel htmlFor="lastname">Last name*</FormLabel>
        //                         <TextField
        //                             id="lastname"
        //                             name="lastname"
        //                             type="text"
        //                             fullWidth
        //                             placeholder=""
        //                             autoComplete="off"
        //                             defaultValue={""}
        //                             {...register('lastname', {required: true})}
        //                             error={Boolean(errors.lastname)}
        //                             helperText={errors.lastname ? errors.lastname.message : ""}
        //                         />
        //                     </FormControl>
        //                     <FormControl>
        //                         <FormLabel htmlFor="email">Email*</FormLabel>
        //                         <TextField
        //                             id="email"
        //                             name="email"
        //                             type="text"
        //                             fullWidth
        //                             placeholder=""
        //                             autoComplete="off"
        //                             variant="outlined"
        //                             defaultValue={""}
        //                             {...register('email', {required: true})}
        //                             error={Boolean(errors.email)}
        //                             helperText={errors.email ? errors.email.message : ""}
        //                         />
        //                     </FormControl>
        //                     <FormControl>
        //                         <FormLabel htmlFor="password">Password*</FormLabel>
        //                         <TextField
        //                             fullWidth
        //                             id="password"
        //                             name="password"
        //                             type="password"
        //                             placeholder=""
        //                             autoComplete="off"
        //                             variant="outlined"
        //                             defaultValue={""}
        //                             {...register('password', {required: true})}
        //                             error={Boolean(errors.password)}
        //                             helperText={errors.password ? errors.password.message : ""}
        //                         />
        //                     </FormControl>
        //                     <FormControlLabel
        //                         control={
        //                                 <>
        //                                     <Checkbox value={"Agreemenmt"} checked={agreementSigned} color="primary" onClick={()=>setAgreementSigned(!agreementSigned)}/>
        //                                     <Typography
        //                                         component="h1"
        //                                         variant="h6"
        //                                         sx={{ width: '100%', fontSize: '14px' }}
        //                                     >
        //                                     I agree to the <Link onClick={()=>handleClickAgreementPageOpen()} variant="body2" sx={{ alignSelf: 'center' }}> terms and conditions </Link>.
        //                                     </Typography>
        //                                 </>
        //                         }
        //                     />
        //                     <UserAgreement open={agreementPage} handleAgreementPageClose={handleAgreementPageClose} setAgreementSigned={setAgreementSigned} />
        //                     <Button
        //                         type="submit"
        //                         fullWidth
        //                         variant="contained"
        //                         disabled={!agreementSigned}
        //                     >
        //                         Sign up
        //                     </Button>
        //                     <Typography sx={{ textAlign: 'center' }}>
        //                         Already have an account?{' '}
        //                             <Link
        //                                 to="/account/login"
        //                                 variant="body2"
        //                                 sx={{ alignSelf: 'center' }}
        //                             >
        //                               Sign in
        //                             </Link>
        //                     </Typography>
        //                 </Box>
        //                 </form>
        //             </Card>
        //         </Stack>
        <Stack variant="outlined" sx={{
            pt: '10%',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <Stack>
                <img
                    src="../assets/images/healthcare/kyol_logo.png"
                    alt="KeyInsight Data Logo"
                    style={{ height: '106px', justifyContent: 'center' }}

                /></Stack>
            <Stack
                sx={{
                    justifyContent: 'space-between', flexGrow: '1', gap: 1
                }}
            >
                <Typography
                    variant="h1"
                    sx={{ fontWeight: '600', fontSize: '45px', mt: 0.5 }}>
                    Sign Up
                </Typography>
            </Stack>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack
                    sx={{
                        // minWidth: '900px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        px: 2
                    }}
                >

                    <Box sx={{
                        justifyContent: 'space-between', width: '100%', maxWidth: '350px', mt: 2
                    }}                    >
                        <FormControl fullWidth>
                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>First name*
                            </Typography>
                            <TextField
                                id="firstname"
                                name="firstname"
                                type="text"
                                autoFocus
                                fullWidth
                                placeholder=""
                                autoComplete="off"
                                defaultValue={""}
                                sx={{
                                    mb: 2, borderRadius: '12px', maxWidth: '350px',
                                    width: '100%'
                                }}
                                {...register('firstname', { required: true })}
                                error={Boolean(errors.firstname)}
                                helperText={errors.firstname ? errors.firstname.message : ""}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Last name*
                            </Typography>
                            <TextField
                                id="lastname"
                                name="lastname"
                                type="text"
                                fullWidth
                                placeholder=""
                                autoComplete="off"
                                defaultValue={""}
                                sx={{
                                    mb: 2, borderRadius: '12px', maxWidth: '350px',
                                    width: '100%'
                                }}
                                {...register('lastname', { required: true })}
                                error={Boolean(errors.lastname)}
                                helperText={errors.lastname ? errors.lastname.message : ""}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Email*
                            </Typography>
                            <TextField
                                id="email"
                                name="email"
                                type="text"
                                fullWidth
                                placeholder=""
                                autoComplete="off"
                                variant="outlined"
                                defaultValue={""}
                                sx={{
                                    mb: 2, borderRadius: '12px', maxWidth: '350px',
                                    width: '100%'
                                }}
                                {...register('email', { required: true })}
                                error={Boolean(errors.email)}
                                helperText={errors.email ?
                                    errors.email.message : ""}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Password*
                            </Typography>
                            <TextField
                                fullWidth
                                id="password"
                                name="password"
                                // type="password"
                                type={showPassword ? 'text' : 'password'}
                                placeholder=""
                                autoComplete="off"
                                variant="outlined"
                                defaultValue={""}
                                sx={{
                                    mb: 2, borderRadius: '12px', maxWidth: '350px',
                                    width: '100%'
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    height: '24px'
                                                }}
                                                onClick={handleTogglePassword}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('password', { required: true })}
                                error={Boolean(errors.password)}
                                helperText={errors.password ? errors.password.message : ""}
                            />
                        </FormControl>

                        <FormControlLabel sx={{ mb: 1 }}
                            control={
                                <>
                                    <Checkbox value={"Agreemenmt"} checked={agreementSigned} color="primary" onClick={() => setAgreementSigned(!agreementSigned)} />
                                    <Typography
                                        component="h1"
                                        variant="h6"
                                        sx={{ width: '100%', fontSize: '14px' }}
                                    >
                                        I agree to the <Link onClick={() => handleClickAgreementPageOpen()} variant="body2" sx={{ alignSelf: 'center' }}> terms and conditions </Link>.
                                    </Typography>
                                </>
                            }
                        />
                        <UserAgreement open={agreementPage} handleAgreementPageClose={handleAgreementPageClose}
                            setAgreementSigned={setAgreementSigned} />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={!agreementSigned}
                            endIcon={<ArrowForwardOutlined />}
                            sx={{
                                borderRadius: '16px', width: '100%', textTransform: 'uppercase',
                                fontWeight: '500', fontSize: '18px', maxWidth: '350px', mb: 2
                            }}
                        >
                            Sign up
                        </Button>

                        <Typography sx={{ textAlign: 'center' }}>
                            Already have an account?{' '}
                            <Link
                                to="/account/login"
                                variant="body2"
                                sx={{ alignSelf: 'center' }}
                            >
                                Sign in
                            </Link>
                        </Typography>
                    </Box>
                </Stack>
            </form>

        </Stack >
    )
}
